module.exports = __webpack_public_path__ + "img/importar-beneficiarios.106de7b2.svg";